import qs from "qs";
import authAxios, { authHeader } from "../data";
import { IBatchPost } from "../../types/Batches";
import { Dayjs } from "dayjs";

const fetchAll = async (req: {
  pageSize: number;
  pageNumber: number;
  from: string | Dayjs;
  to: string | Dayjs;
  type?: number;
}) => {
  const result = await authAxios.get("/api/Batches", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const fetchCount = async (req: { from: string; to: string }) => {
  const result = await authAxios.get("/api/Batches/Count", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return result.data;
};

const fetch = async (id: string) => {
  const result = await authAxios.get("/api/Batches/" + id, {
    headers: authHeader(),
  });

  return result.data;
};

const remove = async (id: string) => {
  const result = await authAxios.delete("/api/Batches/" + id, {
    headers: authHeader(),
  });

  return result.data;
};

const create = async (request: IBatchPost) => {
  const result = await authAxios.post("/api/Batches", request, {
    headers: authHeader(),
  });

  return result.data;
};

const edit = async (request: IBatchPost, id: string) => {
  const result = await authAxios.put("/api/Batches/" + id, request, {
    headers: authHeader(),
  });

  return result.data;
};

const initializeDate = async (requset: string) => {
  const result = await authAxios.post("/api/Batches/Initialize", requset, {
    headers: authHeader(),
  });

  return result.data;
};

const validate = async (id: string) => {
  const result = await authAxios.put(
    `/api/Batches/${id}/calculate`,
    {},
    {
      headers: authHeader(),
    }
  );

  return result.data;
};

const postAll = async (id: string) => {
  const result = await authAxios.put(`/api/Batches/${id}/postAll`, null, {
    headers: authHeader(),
  });

  return result.data;
};

const exportChecks = async (request: any) => {
  const response = await authAxios.get(`/api/Export/Checks`, {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
    responseType: "blob",
  });

  return response.data;
};

const BatchesService = {
  fetchAll,
  fetchCount,
  fetch,
  remove,
  create,
  edit,
  initializeDate,
  validate,
  postAll,
  exportChecks,
};

export default BatchesService;
